export const FeedType = {
    STOCK: 'stock',
    MERCH: 'merch',
    ENRICHMENT: 'enrichment',
}

export function getAllFeedType() {
    return [
        FeedType.STOCK,
        FeedType.MERCH,
        FeedType.ENRICHMENT
    ]
}
